import { render, staticRenderFns } from "./ModalUploadPlanilhaErroDetalhes.vue?vue&type=template&id=10f0dab6&lang=pug"
import script from "./ModalUploadPlanilhaErroDetalhes.vue?vue&type=script&lang=js"
export * from "./ModalUploadPlanilhaErroDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports